import React, { memo } from 'react'

import Text from './Text'

const SubHead = ({ t, value, approx, sx }) => {
  return (
    <Text
      variant='body1'
      component='span'
      label={
        approx ? (
          <>
            &#x2248;
            {` ${t('staking.up-to')} $${value}`}
          </>
        ) : (
          value
        )
      }
      sx={{ mt: 1.5, ml: 1, ...sx }}
    />
  )
}

export default memo(SubHead)
